import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import ExpandableContent from '../../components/global/ExpandableContent/ExpandableContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

function getRoleString(role) {
    if (!role) {
        return '';
    }
    const [firstLetter] = role;
    const restOfLetters = role.substring(1);
    return `(${firstLetter.toUpperCase()}${restOfLetters.toLowerCase()})`;
}

function PdpSharedDescriptionAboutCreator(props) {
    const { headerClass, contentClass, item } = props;
    const { role, name, description } = get(item, 'creatorContent') || {};

    if (!name || !description) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description-about-creator" className={styles.wrapper}>
            <h2 className={classNames(styles.header, headerClass)}>
                <FormattedMessage
                    id="PdpSharedDescriptionAboutCreator.creatorTitle"
                    defaultMessage="About {name} {role}"
                    values={{ name, role: getRoleString(role) }}
                />
            </h2>
            <ExpandableContent
                className={classNames(styles.creatorContent, contentClass)}
                buttonClassName={styles.button}
                collapseHeight={72}
            >
                <span dangerouslySetInnerHTML={{ __html: description }} />
            </ExpandableContent>
        </div>
    );
}

PdpSharedDescriptionAboutCreator.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDescriptionAboutCreator, {
    item: graphql`
        fragment PdpSharedDescriptionAboutCreator_item on Item {
            creatorContent {
                name
                description
                role
            }
        }
    `,
});
